<section class="transactions-page" aria-labelledby="transactions-title">
  <div class="transactions-card invoice-table">
                <header class="transactions-heading">
                  <h1 id="transactions-title" class="sam-page-heading">EKONOMI ({{ listLength }})</h1>
                  <p>
                    Här ser du hur vi har räknat ut din lön. Om du skickat din faktura till en svensk kund i SEK ser du den här så fort du skickat den till oss. Om du skickat den i annan valuta dyker den upp så fort vi granskat den och skickat den till din kund.
                  </p>
                  <p>
                    Om du har en kund som fakturerat för din räkning, eller använder oss som löneadministratör, ser du bara utbetalningsdatumen för de fakturorna.
                  </p>
                  <p>
                    Observera att utbetalningsdatum för fakturor som ännu inte har betalats ut är preliminära och baseras på fakturans förfallodatum.
                  </p>
                </header>

                <div class="transactions-toolbar">
                  <div class="transaction-search-shell">
                    <mat-icon aria-hidden="true">search</mat-icon>
                    <input class="transaction-search"
                           [(ngModel)]="search"
                           type="search"
                           name="search"
                           id="search"
                           (ngModelChange)="this.searchUpdate.next($event)"
                           placeholder="Sök"
                           aria-label="Sök ekonomi" />
                  </div>
                </div>
                <div class="table-shell">
                <div class="table-scroll">
                  <div *ngIf="isLoading"
                       class="transactions-skeleton"
                       [class.transactions-skeleton-admin]="isAdmin"
                       aria-hidden="true">
                    <div class="transactions-skeleton-row" *ngFor="let _ of [1,2,3,4,5]">
                      <span></span><span></span><span *ngIf="isAdmin"></span><span></span><span></span>
                    </div>
                  </div>

                  <mat-table class="transactions-table" [dataSource]="dataSource" [class.isMobile]="isMobile" [class.transactions-table-loading]="isLoading" matSort (matSortChange)="sortData($event)" matSortActive="name" matSortDirection="asc" matSortDisableClear>


                <ng-container matColumnDef="id">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Faktura </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <div *ngIf="row.TransactionLogs.length != 0 && (row?.InvoiceDocument?.Guid || row?.InvoiceDocument?.Url)"><a href="" (click)="openInvoiceDocument(row?.InvoiceDocument, $event)">{{row?.Id}}</a> </div>
                    <div *ngIf="row.TransactionLogs.length != 0 && !row?.InvoiceDocument?.Guid && !row?.InvoiceDocument?.Url">{{row?.Id}}</div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="customer">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Kund </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span class="mobile-label">Din kund:</span>
                    <div *ngIf="'row.TransactionLogs.length != 0' && 'row?.Customer != null'">{{row?.Customer?.Name}}</div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="user">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Medlem </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span class="mobile-label">Din kund:</span>
                    <div *ngIf="'row.TransactionLogs.length != 0' && 'row?.Customer? != null'">{{row?.UserSettings?.FirstName + ' ' + row?.UserSettings?.LastName}}</div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="invoicenumber">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Fakturanummer </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span class="mobile-label invoiceNumberMobile">Fakturanummer:</span>
                    <div *ngIf="row.TransactionLogs.length != 0 && (row?.InvoiceDocument?.Guid || row?.InvoiceDocument?.Url)"><a class="transaction-invoice-link" href="" (click)="openInvoiceDocument(row?.InvoiceDocument, $event)"><mat-icon class="transaction-invoice-icon" aria-hidden="true">description</mat-icon>{{row?.InvoiceNumber}}</a> </div>
                    <div *ngIf="row.TransactionLogs.length != 0 && !row?.InvoiceDocument?.Guid && !row?.InvoiceDocument?.Url">{{row?.InvoiceNumber}}</div>
                    <div *ngIf="row?.InvoiceNumber == null">-</div>
                    <span class="mobile-invoice-separator" *ngIf="row?.InvoiceNumber != null" aria-hidden="true">-</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="payment">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Inbetalningsdatum </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <ng-container *ngIf="getPaymentTransactionLog(row) as paymentLog">
                      <span class="mobile-label">{{paymentLog?.IsPreliminary ? 'Prel. inbetalningsdatum:' : 'Inbetalningsdatum:'}}</span>
                      <div (click)="openDialog('payment', row)" class="transaction-date pointer prel accent" *ngIf="paymentLog?.IsPreliminary == true && !row?.SubInvoice"><span class="transaction-date-value">{{paymentLog?.PaymentDue | swedishDate: 'yyyy-MM-dd'}}</span><span class="transaction-date-icon"><mat-icon class="iconPreli" color="accent" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Detta är ett preliminärt datum">info</mat-icon></span></div>
                      <div (click)="openDialog('payment', row)" class="transaction-date pointer accent" *ngIf="paymentLog?.IsPreliminary == false && !row?.SubInvoice"><span class="transaction-date-value">{{ paymentLog?.PaymentDate | swedishDate: 'yyyy-MM-dd' }}</span><span class="transaction-date-icon" aria-hidden="true"></span></div>
                    </ng-container>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="payout">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Utbetalningsdatum </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <ng-container *ngIf="getPayoutTransactionLog(row) as payoutLog">
                      <span class="mobile-label">{{payoutLog?.IsPreliminary ? 'Prel. utbetalningsdatum:' : 'Utbetalningsdatum:'}}</span>
                      <div (click)="openDialog('payout', row)" class="transaction-date pointer prel accent" *ngIf="payoutLog?.IsPreliminary == true"><span class="transaction-date-value">{{getPrelPayoutDate(payoutLog?.PaymentDue, row?.ExpressPayOut, payoutLog?.Created, row?.Created) | swedishDate: 'yyyy-MM-dd'}}</span><span class="transaction-date-icon"><mat-icon class="iconPreli" color="accent" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Detta är ett preliminärt datum">info</mat-icon></span></div>
                      <div (click)="openDialog('payout', row)" class="transaction-date pointer accent" *ngIf="row?.Type?.TechnicalName != 'CommissionCashInvoice' && payoutLog?.IsPreliminary == false"><span class="transaction-date-value">{{payoutLog?.PayoutDate | swedishDate: 'yyyy-MM-dd'}}</span><span class="transaction-date-icon" aria-hidden="true"></span></div>
                      <div class="transaction-date accent" *ngIf="row?.Type?.TechnicalName == 'CommissionCashInvoice'"><span class="transaction-date-value">{{payoutLog?.PayoutDate | swedishDate: 'yyyy-MM-dd'}}</span><span class="transaction-date-icon" aria-hidden="true"></span></div>
                    </ng-container>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;">
                </mat-row>
                  </mat-table>
                  <div *ngIf="!isLoading && !dataSource?.data?.length" class="transactions-empty">
                    Inga ekonomihändelser hittades.
                  </div>
                </div>
                <div class="invoice-paginator">
                  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" (page)="onPaginatorChange(paginator)" [pageIndex]="0" [length]="listLength" showFirstLastButtons="true"></mat-paginator>
                </div>
                </div>
  </div>
</section>

      <!--Shows all transaction logs separately to admin-->
      <!--<mat-card class="mat-elevation-z0" [hidden]="!isAdmin">
        <mat-card class="mat-elevation-z0">
          <div class="container-margin container">
            <mat-card-content class="mat-elevation-z8">

              <div class="d-none d-lg-block">
                <div class="col">
                  <mat-card-title>ALLA TRANSAKTIONSRADER (ADMIN)</mat-card-title>
                </div>
                <div class="col d-flex justify-content-between" style="background-color: #FAFAFA;">
                  <div class="col">
                    <mat-form-field color="accent" appearance="standard">
                      <mat-label>Sök</mat-label>
                      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Hitta rätt faktura">
                      <mat-icon matSuffix color="accent">search</mat-icon>
                    </mat-form-field>
                  </div>

                </div>
              </div>-->
      <!--This activates the correct default sort-->
      <!--<table mat-table matSort [dataSource]="dataSourceAdmin" matSortActive="date" matSortDirection="asc" #mytable class="my-table">

                <ng-container matColumnDef="id">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef> <span style="color: #E91E63">Fakturaid </span></th>
                  <td mat-cell *matCellDef="let element">{{element?.Invoice?.Id}}</td>
                </ng-container>

                <ng-container matColumnDef="invoicenumberadm">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef> <span style="color: #E91E63">Fakturanr </span></th>
                  <td mat-cell *matCellDef="let element">
                    <a href="" (click)="openInvoiceDocument(element?.Invoice?.InvoiceDocument, $event)">
                      <span *ngIf="element?.PayoutDate != null || element?.PaymentDate != null ">{{element?.Invoice?.InvoiceNumber}}</span>
                    </a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="customer">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef> <span style="color: #E91E63">Kund </span></th>
                  <td mat-cell *matCellDef="let element">{{element?.Invoice?.Customer.Name}} </td>
                </ng-container>

                <ng-container matColumnDef="member">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef> <span style="color: #E91E63">Medlem </span></th>
                  <td mat-cell *matCellDef="let element">{{element?.Invoice?.UserSettings?.FirstName}} {{element?.Invoice?.UserSettings?.LastName}}</td>
                </ng-container>

                <ng-container matColumnDef="paymentdate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef> <span style="color: #E91E63">Inbetalat från kund </span></th>
                  <td mat-cell (click)="openDialogAdmin('open',element)" class="pointer" *matCellDef="let element">
                    <span *ngIf="element?.PaymentDate != null">{{element?.PaymentDate | swedishDate:'yyyy-MM-dd'}}</span>
                    <span class="italic" *ngIf="element?.PaymentDate == null && element?.IsPayoutTransLog == false">{{element?.Invoice?.PaymentDue | swedishDate:'yyyy-MM-dd'}} (prel)</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="payoutdate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef> <span style="color: #E91E63">Utbetalat till konto</span></th>
                  <td mat-cell (click)="openDialogAdmin('open',element)" class="pointer" *matCellDef="let element">
                    <span *ngIf="element?.PayoutDate != null">{{element?.PayoutDate | swedishDate:'yyyy-MM-dd'}}</span>
                    <span class="italic" *ngIf="element?.PayoutDate == null && element?.IsPayoutTransLog == true">{{element?.Invoice?.PaymentDue | swedishDate:'yyyy-MM-dd'}} (prel)</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="admin">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef> <span style="color: #E91E63">Admin</span></th>
                  <td mat-cell class="pointer" *matCellDef="let element">
                    <a mat-icon-button (click)="deleteTransactionLog(element?.Id)" style="color:red;" class="pointer"><mat-icon>delete_forever</mat-icon></a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="icon">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef style="padding: 0 !important;"><span style="color: #E91E63">Se beräkning</span></th>
                  <td mat-cell (click)="openDialog('Update',element)" class="pointer" *matCellDef="let element" style="padding: 0 !important;"><mat-icon color="accent">list_alt</mat-icon></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsAdmin"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsAdmin;"></tr>

              </table>
              <mat-paginator [pageSizeOptions]="[5, 20, 50, 100, 500]" [pageSize]="10" [pageIndex]="0" [length]="listLength" showFirstLastButtons="true"></mat-paginator>
            </mat-card-content>
          </div>
        </mat-card>
      </mat-card>-->

